export const getEnvironment = () => {
  if (window.location.hostname === 'qrorder-admin.ubiregi.com' || window.location.port === '8976') return 'production';
  if (window.location.hostname === 'localhost' && window.location.port === '9999') return 'test';
  return 'development';
};
